import { Layout } from './Layout';

export const LassoItemMargin = {
  [Layout.Gallery]: 14,
  [Layout.List]: 0,
  [Layout.SmartGrid]: 6,
  DEFAULT: 0,
};
